module.exports = __webpack_public_path__ + "static/media/fvs_valve1_74.d21eaac6.jpg";